<template>
  <div :class="{ disabled: $bus.drawing }" class="mainpage" v-if="contentCome">
    <m-header />
    <div class="main-layout layout1">
      <div class="bg-ball"></div>
    </div>
    <div class="bg-front"></div>
    <div class="main-layout layout2">
      <discount-refresh />
      <magic-ball />
      <pool-refresh />
    </div>
    <!-- 隐私声明弹窗 -->
    <Alert :show.sync="alertShow" :title="alertTitle" :content="alertContent" />
    <EuPolicyAlert :show.sync="euPolicyShow" :content="euPolicyContent" :storageText="euPolicyChoiceContent.storageText" :adText="euPolicyChoiceContent.adText"></EuPolicyAlert>
  </div>
</template>
<script>
  import MHeader from '@/components/m-header/m-header'
  import MagicBall from '@/components/magic-ball/magic-ball'
  import DiscountRefresh from '@/components/discount-refresh/discount-refresh'
  import PoolRefresh from '@/components/pool-refresh/pool-refresh'
  import Alert from '@/components/Alert'
  import EuPolicyAlert from '@/components/EuPolicyAlert.vue'
  import { setSessionStorage, getSessionStorage, initGA, addGA, errorGA, defaultConsentGa, updateConsentGA } from '@/utils/assist'
  export default {
    name: 'home',
    data () {
      return {
        // transify: this.$bus.transify, // 不具有观测性
        globalConfig: this.$bus.$data, // 全局被观测数据对象
        contentCome: false,
        alertShow: false,
        alertTitle: '',
        alertContent: '',
        euPolicyShow: false,
        euPolicyContent: '',
        euPolicyChoiceContent: {
            storageText: '',
            adText: ''
        }
      }
    },
    components: {
      MHeader,
      MagicBall,
      DiscountRefresh,
      PoolRefresh,
      Alert,
      EuPolicyAlert
    },
    methods: {
      initInfo () {
        let accessToken = getSessionStorage(`${PROJECT_NAME}AccessToken`) || ''
        let lang = getSessionStorage(`${PROJECT_NAME}Lang`) || ''
        let region = getSessionStorage(`${PROJECT_NAME}Region`) || ''
        if (!accessToken) return this.$bus.handleError('TOAST_LOGIN_FAILED', false)
        this.$api
          .info({
            access_token: accessToken,
            lang: lang,
            region: region
          })
          .then(response => {
            // NOTE error state has been already handled in request.js
            let data = response.data
            this.$bus.uid = data.uid
            this.$bus.gems = data.gems
            this.$bus.discount = data.discount
            this.$bus.rules = data.event.rules
            this.$bus.refreshable = data.refreshable
            this.$bus.discountRefreshInfo = {
              timesFree: data.discount_refresh_free_times,
              times: data.discount_refresh_times,
              limitsFree: data.event.discount_free_times_limit,
              limits: data.event.discount_refresh_limit,
              cost: data.event.refresh_discount_cost
            }
            this.$bus.poolRefreshInfo = {
              timesFree: data.pool_refresh_free_times,
              times: data.pool_refresh_times,
              limitsFree: data.event.pool_free_times_limit,
              limits: data.event.pool_refresh_limit,
              cost: data.event.refresh_pool_cost
            }
            this.$bus.reward = this.$bus.formatReward(data.reward)
            this.$bus.history = this.$bus.formatHistory(data.history)
            this.$bus.lang = data.event.lang
            Object.assign(this.$bus.transify, data.event.transify)
            document.body.setAttribute('data-lang', this.$bus.lang)
            initGA(data.event.region, this.$bus.uid, data.event.data_log_name)

            if (data.policy_popup) {
              const {
                popup_title: policyTitle,
                popup_content: policyCtx,
                checked: policyHide
              } = data.policy_popup
              this.alertShow = !policyHide
              this.alertTitle = policyTitle
              this.alertContent = policyCtx
            }
            if (data['google_analytics_popup']) {
                defaultConsentGa()
                const {
                    popup_content: policyCtx,
                    checked: policyHide,
                    storage_choice_text,
                    ad_choice_text,
                    choices
                } = data['google_analytics_popup']
                this.euPolicyShow = !policyHide
                this.euPolicyContent = policyCtx
                this.euPolicyChoiceContent.storageText = storage_choice_text
                this.euPolicyChoiceContent.adText = ad_choice_text
                if (policyHide) {
                  updateConsentGA(choices)
                }
            }
            this.contentCome = true
          })
          .catch(error => {
            // NOTE error has been already handled in request.js
            console.log(error, 'initInfo...')
          })
      }
    },
    created () {},
    mounted () {
      this.initInfo()
    }
  }
</script>
<style lang="scss" scoped>
  .mainpage {
    position: relative;
    height: 100vh;
    overflow: hidden;
    &.disabled {
      pointer-events: none;
    }
    .main-layout {
      position: absolute;
      width: 100%;
      left: 0;
      top: 50%;
      @include px2res(height, $ui-height);
      transform: translateY(-50%);
      &.layout1 {
        z-index: 1;
      }
      &.layout2 {
        z-index: 3;
      }
    }
    .bg-ball {
      position: absolute;
      bottom: 0;
      left: 50%;
      @include px2res(width, 774);
      @include px2res(height, 742);
      transform: translateX(-50%);
      animation: ball_breath infinite alternate 1s linear;
    }
    .bg-front {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      @include px2res(height, 272);
      z-index: 2;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue